// @flow
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, Typography} from '@material-ui/core';
import {ArrowForwardIos} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';
import {Link, Route, Switch} from 'react-router-dom';
import AccountsCollaboratorsContainer from './containers/AccountsCollaboratorsContainer';
// import AccountsSellersContainer from './containers/AccountsSellersContainer';
// import AccountsInfluencersContainer from './containers/AccountsInfluencersContainer';
import {usePage} from '../../page/utils';

import type {Store} from '../../../entities';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {useIsFeatureInTier} from '../../../utils/component';

type Props = {|
  store?: Store,
|};

type SubRoute = {
  name: string,
  path: string,
  disabled?: boolean,
  component?: () => any,
  editComponent?: () => any,
  secondLine?: string,
  id?: string,
};

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    // backgroundColor: 'white',
    // borderRadius: '12px',
    // overflow: 'hidden',
  },
  button: {
    marginBottom: theme.spacing(2),
    borderRadius: '12px',
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    backgroundColor: 'white',
    textAlign: 'left',
    justifyContent: 'flex-start',
    // maxHeight: 76,
  },
  startIcon: {
    marginRight: theme.spacing(2),
  },
  endIcon: {
    marginLeft: 'auto',
    color: colors.grey800,
  },
  divider: {
    background: colors.grey200,
  },
  label: {
    fontWeight: 600,
    fontSize: '1rem',
    whiteSpace: 'break-spaces',
    color: colors.grey800,
    '&.disabled': {
      color: colors.grey500,
    },
  },
  secondLine: {
    whiteSpace: 'normal',
    color: colors.grey800,
    fontSize: '0.75rem',
    '&.disabled': {
      color: colors.grey500,
    },
  },
}));

export default usePage<Props>(Accounts, 'Accounts Configuration');

function Accounts(props: Props) {
  // const {store} = props;

  const classes = useStyles();

  // const [tierRestricted, setTierRestricted] = useState(false);

  const hasCollaboratorsFeature = useIsFeatureInTier('STORE_COLLABORATOR');

  const subRoutes: {[key: string]: SubRoute} = useMemo(
    () => ({
      collaborators: {
        name: 'Colaboradores',
        secondLine:
          'Aquí podría ir una pequeña descripción de lo que es un colaborador.',
        path: '/configure/accounts/collaborators',
        component: AccountsCollaboratorsContainer,
        id: 'collaborators',
        disabled: !hasCollaboratorsFeature,
      },
      // sellers: {
      //   name: 'Vendedores',
      //   secondLine:
      //     'Aquí podría ir una pequeña descripción de lo que es un colaborador.',
      //   path: '/configure/accounts/sellers',
      //   component: tierRestricted ? () => null : AccountsSellersContainer,
      //   editComponent: tierRestricted
      //     ? () => null
      //     : AccountsSellerEditContainer,
      //   id: 'sellers',
      // },
      // influencers: {
      //   name: 'Influencers',
      //   secondLine:
      //     'Aquí podría ir una pequeña descripción de lo que es un colaborador.',
      //   path: '/configure/accounts/influencers',
      //   component: tierRestricted ? () => null : AccountsInfluencersContainer,
      //   editComponent: () => null,
      //   // editComponent: tierRestricted
      //   //   ? () => null
      //   //   : AccountsInfluencerEditContainer,
      //   id: 'influencers',
      // },
    }),
    [hasCollaboratorsFeature]
  );

  const subRoutesArray = Object.keys(subRoutes).map(k => subRoutes[k]);

  // const subRoute: ?SubRoute = subRoutesArray.find(
  //   (route: SubRoute) => location.pathname === route.path
  // );

  return (
    <div className={classes.root}>
      <Switch>
        <Route exact path="/configure/accounts">
          {subRoutesArray.map((route: SubRoute, idx: number) => (
            <CustomButton
              key={`accounts-subroute-${idx}`}
              classes={{
                root: classes.button,
                startIcon: classes.startIcon,
                endIcon: classes.endIcon,
              }}
              color="default"
              endIcon={
                <ArrowForwardIos
                  style={{
                    fontSize: '1rem',
                    color: route.disabled ? colors.grey300 : undefined,
                  }}
                />
              }
              disabled={route.disabled}
              component={Link}
              to={route.path}
            >
              <div>
                <Typography
                  className={`${classes.label} ${
                    route.disabled ? 'disabled' : ''
                  }`}
                  id={route.id}
                >
                  {route.name}
                </Typography>
                {route.secondLine && (
                  <Typography
                    className={`${classes.secondLine} ${
                      route.disabled ? 'disabled' : ''
                    }`}
                  >
                    {route.secondLine}
                  </Typography>
                )}
              </div>
            </CustomButton>
          ))}
        </Route>
        {subRoutesArray.map((route: SubRoute, idx: number) => (
          <Route
            key={`accounts-route-${idx}`}
            path={route.path}
            component={route.component}
          />
        ))}
      </Switch>
    </div>
  );
}

Accounts.propTypes = {
  store: PropTypes.object,
};
